import { ReactNode } from "react";

interface EditorPanelProps {
    title: ReactNode;
    /** Trailing controls of the panel — Cancel / Save. */
    actions?: ReactNode;
    children: ReactNode;
}

/**
 * The inline add / edit form, framed as a distinct surface.
 *
 * The forms used to appear as loose fields between the toolbar and the table,
 * so entering edit mode read as the page shifting rather than as a mode change.
 * A titled card with an accent edge and its own footer makes the mode obvious.
 */
export const EditorPanel = ({ title, actions, children }: EditorPanelProps) => (
    <section className="editor-panel">
        <header className="editor-panel__head">
            <span className="editor-panel__title">{title}</span>
        </header>
        <div className="editor-panel__body">{children}</div>
        {actions != null ? <footer className="editor-panel__foot">{actions}</footer> : null}
    </section>
);
